module.exports = __webpack_public_path__ + "img/Winner-7.8ac025ed.jpg";